module.exports = __webpack_public_path__ + "static/media/img_g4.22f85b40.webp";